import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import FieldLabel from '../FieldLabel';

const DropdownField = ({ label, name, options, placeholder, ...props }) => {
    const { control } = useFormContext();

    return (
        <>
            {label && <FieldLabel label={label} name={name} />}

            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value, ref }, formState: { errors } }) => (
                    <Select
                        id={name}
                        inputRef={ref}
                        className={`react-select-container ${errors[name] ? 'error' : ''}`}
                        classNamePrefix="react-select"
                        placeholder={placeholder}
                        options={options}
                        value={options ? options.find((x) => x.value === value) : {}}
                        isSearchable={false}
                        onChange={({ value }) => onChange(value)}
                        { ...props }
                    />
                )}
            />
        </>
    );
};

DropdownField.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    name: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
};

DropdownField.defaultProps = {
    label: '',
    name: '',
    options: [],
    placeholder: '',
};

export default DropdownField;
